/* Module Free Gift - stable + no flicker
   Notes:
   - Uses pending lock to prevent mobile flicker during re-renders
   - Dedupe and qty changes use line item key when possible
   - Script runs once only
*/

(function () {
  if (window.__ModuleFreeGift && window.__ModuleFreeGift.running) return;
  window.__ModuleFreeGift = window.__ModuleFreeGift || {};
  window.__ModuleFreeGift.running = true;

  var cfg = window.ModuleFreeGiftConfig || {};

  var THRESHOLD_CENTS = Number(cfg.thresholdCents || 9500);
  var GIFT_VARIANT_ID = Number(cfg.giftVariantId || 52324303831368);
  var USE_ORIGINAL_PRICES = !!cfg.useOriginalPricesForThreshold;
  var DEBUG = !!cfg.debug;

  var GIFT_PROP_KEY = "_module_free_gift";
  var GIFT_PROP_VAL = "true";

  var isSyncing = false;
  var needsResync = false;
  var scheduled = null;

  var moStarted = false;
  var isRendering = false;

  // Cached state to prevent flicker on re-render
  var lastEligible = false;
  var lastGiftPresent = false;
  var lastGiftShouldLock = false; // true only when gift is actually free

  function log() {
    if (!DEBUG) return;
    try { console.log.apply(console, arguments); } catch (e) {}
  }

  function ensureStyles() {
    if (document.getElementById("module-free-gift-styles")) return;

    // Pending behaves the same as locked (hides controls) to prevent flicker
    var css = ""
      + ".module-free-gift-locked cart-remove-button,"
      + ".module-free-gift-locked .cart-remove-button,"
      + ".module-free-gift-locked button[name='remove'],"
      + ".module-free-gift-locked [aria-label*='Remove'],"
      + ".module-free-gift-locked [aria-label*='remove'],"
      + ".module-free-gift-pending cart-remove-button,"
      + ".module-free-gift-pending .cart-remove-button,"
      + ".module-free-gift-pending button[name='remove'],"
      + ".module-free-gift-pending [aria-label*='Remove'],"
      + ".module-free-gift-pending [aria-label*='remove']{display:none!important}"

      + ".module-free-gift-locked .cart-item__quantity,"
      + ".module-free-gift-locked .cart-item__quantity-wrapper,"
      + ".module-free-gift-locked .quantity,"
      + ".module-free-gift-locked quantity-input,"
      + ".module-free-gift-locked .quantity__wrapper,"
      + ".module-free-gift-pending .cart-item__quantity,"
      + ".module-free-gift-pending .cart-item__quantity-wrapper,"
      + ".module-free-gift-pending .quantity,"
      + ".module-free-gift-pending quantity-input,"
      + ".module-free-gift-pending .quantity__wrapper{display:none!important}"

      + ".module-free-gift-locked .cart-item__variant,"
      + ".module-free-gift-locked .cart-item__options,"
      + ".module-free-gift-locked .product-option,"
      + ".module-free-gift-locked .cart-item__details dl,"
      + ".module-free-gift-locked .cart-item__details .properties,"
      + ".module-free-gift-pending .cart-item__variant,"
      + ".module-free-gift-pending .cart-item__options,"
      + ".module-free-gift-pending .product-option,"
      + ".module-free-gift-pending .cart-item__details dl,"
      + ".module-free-gift-pending .cart-item__details .properties{display:none!important}"

      + ".module-free-gift-locked variant-selects,"
      + ".module-free-gift-locked variant-radios,"
      + ".module-free-gift-locked .variant-picker,"
      + ".module-free-gift-locked select[name='id'],"
      + ".module-free-gift-locked select[data-variant-select],"
      + ".module-free-gift-pending variant-selects,"
      + ".module-free-gift-pending variant-radios,"
      + ".module-free-gift-pending .variant-picker,"
      + ".module-free-gift-pending select[name='id'],"
      + ".module-free-gift-pending select[data-variant-select]{display:none!important}";

    var style = document.createElement("style");
    style.id = "module-free-gift-styles";
    style.textContent = css;
    document.head.appendChild(style);
  }

  function isCartUrl(url) {
    if (!url) return false;
    return /\/cart(?:\/(add|change|update|clear)(?:\.js)?|\.js)(\?|$)/.test(url);
  }

  function isAddUrl(url) {
    if (!url) return false;
    return /\/cart\/add(?:\.js)?(\?|$)/.test(url);
  }

  function safeJson(res) {
    if (!res || !res.json) return Promise.reject(new Error("Bad response"));
    return res.json();
  }

  function fetchCart() {
    return fetch("/cart.js", {
      credentials: "same-origin",
      headers: { Accept: "application/json" }
    }).then(safeJson);
  }

  function unique(arr) {
    var out = [];
    for (var i = 0; i < (arr || []).length; i++) {
      var v = arr[i];
      if (!v) continue;
      if (out.indexOf(v) === -1) out.push(v);
    }
    return out;
  }

  function getSectionsToRequest() {
    var ids = [];

    var drawer = document.querySelector("cart-drawer");
    if (drawer && typeof drawer.getSectionsToRender === "function") {
      try { drawer.getSectionsToRender().forEach(function (s) { if (s && s.id) ids.push(s.id); }); } catch (e) {}
    }

    var cartItems = document.querySelector("cart-items");
    if (cartItems && typeof cartItems.getSectionsToRender === "function") {
      try { cartItems.getSectionsToRender().forEach(function (s) { if (s && s.id) ids.push(s.id); }); } catch (e) {}
    }

    if (document.getElementById("shopify-section-cart-icon-bubble")) ids.push("cart-icon-bubble");
    if (document.getElementById("shopify-section-cart-drawer")) ids.push("cart-drawer");
    if (document.getElementById("shopify-section-main-cart-items")) ids.push("main-cart-items");
    if (document.getElementById("shopify-section-main-cart-footer")) ids.push("main-cart-footer");

    ids.push("cart-icon-bubble");
    return unique(ids);
  }

  function postCart(url, body) {
    var sections = getSectionsToRequest();
    var payload = Object.assign({}, body, {
      sections: sections,
      sections_url: window.location.pathname
    });

    return fetch(url, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Module-FreeGift": "1"
      },
      body: JSON.stringify(payload)
    }).then(safeJson);
  }

  function renderSections(state) {
    if (!state || !state.sections) return;

    isRendering = true;
    try {
      var drawer = document.querySelector("cart-drawer");
      var cartItems = document.querySelector("cart-items");

      var handled = {};

      if (drawer && typeof drawer.renderContents === "function") {
        try { drawer.renderContents(state); } catch (e) {}
        handled["cart-drawer"] = true;
      }

      if (cartItems && typeof cartItems.renderContents === "function") {
        try { cartItems.renderContents(state); } catch (e) {}
        handled["main-cart-items"] = true;
        handled["main-cart-footer"] = true;
      }

      Object.keys(state.sections).forEach(function (key) {
        if (handled[key]) return;
        var wrap = document.getElementById("shopify-section-" + key);
        if (wrap) wrap.innerHTML = state.sections[key];
      });
    } finally {
      // Immediately re-apply cached lock to new DOM to prevent flicker
      applyLockFromCacheToDom();
      window.setTimeout(function () { isRendering = false; }, 60);
      patchThemeRenderHooks();
    }
  }

  function isGiftItem(item) {
    return !!(item && item.properties && item.properties[GIFT_PROP_KEY] === GIFT_PROP_VAL);
  }

  // Consider gift candidate if it is our variant id (even if properties were stripped)
  function isGiftCandidate(item) {
    if (!item) return false;
    return isGiftItem(item);
  }

  function giftDiscountActive(item) {
    if (!item) return false;
    if (typeof item.final_line_price === "number" && item.final_line_price === 0) return true;
    var alloc = item.discount_allocations || item.line_level_discount_allocations || [];
    return Array.isArray(alloc) && alloc.length > 0;
  }

  function calcEligibleCents(cart) {
    var sum = 0;
    (cart.items || []).forEach(function (item) {
      if (isGiftCandidate(item)) return;
      var v = USE_ORIGINAL_PRICES ? (item.original_line_price || 0) : (item.final_line_price || 0);
      sum += v;
    });
    return sum;
  }

  function findAllGiftLines(cart) {
    var out = [];
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      if (isGiftCandidate(items[i])) {
        out.push({ item: items[i], line: i + 1, key: items[i].key || null });
      }
    }
    return out;
  }

  function bestGiftLine(lines) {
    if (!lines || !lines.length) return null;

    // Prefer discounted/free, then one with our property, then first
    for (var i = 0; i < lines.length; i++) {
      if (giftDiscountActive(lines[i].item)) return lines[i];
    }
    for (var j = 0; j < lines.length; j++) {
      if (isGiftItem(lines[j].item)) return lines[j];
    }
    return lines[0];
  }

  function findGift(cart) {
    return bestGiftLine(findAllGiftLines(cart));
  }

  function addGiftWithSections() {
    var props = {};
    props[GIFT_PROP_KEY] = GIFT_PROP_VAL;

    log("[FreeGift] add gift", GIFT_VARIANT_ID);

    return postCart("/cart/add.js", {
      id: GIFT_VARIANT_ID,
      quantity: 1,
      properties: props
    });
  }

  function setQtyWithSections(lineObj, qty) {
    if (!lineObj) return Promise.resolve(null);

    if (lineObj.key) {
      log("[FreeGift] change by key", lineObj.key, "qty", qty);
      return postCart("/cart/change.js", { id: lineObj.key, quantity: qty });
    }

    log("[FreeGift] change by line", lineObj.line, "qty", qty);
    return postCart("/cart/change.js", { line: lineObj.line, quantity: qty });
  }

  function waitForGiftToBecomeFree(maxTries, delayMs) {
    var tries = typeof maxTries === "number" ? maxTries : 6;
    var delay = typeof delayMs === "number" ? delayMs : 250;

    return fetchCart().then(function (cart) {
      var gift = findGift(cart);
      if (gift && giftDiscountActive(gift.item)) return cart;
      if (tries <= 0) return cart;

      return new Promise(function (res) { window.setTimeout(res, delay); })
        .then(function () { return waitForGiftToBecomeFree(tries - 1, delay); });
    });
  }

  function clearAllGiftStates() {
    var els = document.querySelectorAll(".module-free-gift-locked, .module-free-gift-pending");
    for (var i = 0; i < els.length; i++) {
      els[i].classList.remove("module-free-gift-locked");
      els[i].classList.remove("module-free-gift-pending");
    }
  }

  // Find gift row(s) by variant id using your theme attributes
  function getGiftRoots() {
    var roots = [];
    var seen = [];

    function pushUnique(el) {
      if (!el) return;
      if (seen.indexOf(el) !== -1) return;
      seen.push(el);
      roots.push(el);
    }

    try {
      // Only lock rows explicitly marked as the free gift in Liquid
      var marked = document.querySelectorAll('[data-module-free-gift="true"]');
      for (var i = 0; i < marked.length; i++) {
        pushUnique(marked[i]);
      }
    } catch (e) {}

    return roots;
  }

  // Key function: apply cached lock immediately to DOM (prevents flicker)
  function applyLockFromCacheToDom() {
    var roots = getGiftRoots();

    // If gift not even in DOM, clear leftover classes on old nodes
    if (!roots.length) {
      clearAllGiftStates();
      return;
    }

    // If not eligible or gift not present, clear
    if (!lastEligible || !lastGiftPresent) {
      clearAllGiftStates();
      return;
    }

    // Eligible + gift present: apply pending instantly
    for (var i = 0; i < roots.length; i++) {
      roots[i].classList.remove("module-free-gift-locked");
      roots[i].classList.add("module-free-gift-pending");
    }

    // If confirmed free: upgrade to locked
    if (lastGiftShouldLock) {
      for (var j = 0; j < roots.length; j++) {
        roots[j].classList.remove("module-free-gift-pending");
        roots[j].classList.add("module-free-gift-locked");
      }
    }
  }

  // Update cache from cart and apply to DOM
  function applyLockFromCart(cart) {
    var eligible = calcEligibleCents(cart) >= THRESHOLD_CENTS;
    var gifts = findAllGiftLines(cart);
    var gift = bestGiftLine(gifts);

    lastEligible = eligible;
    lastGiftPresent = !!gift;
    lastGiftShouldLock = !!(eligible && gift && giftDiscountActive(gift.item));

    applyLockFromCacheToDom();
  }

  // Remove duplicates safely (by key). Never uses shifting line numbers against paid items.
  function dedupeGiftsIfNeeded(cart) {
    var gifts = findAllGiftLines(cart);
    if (!gifts || gifts.length <= 1) return Promise.resolve(cart);

    var keep = bestGiftLine(gifts);
    var remove = [];

    for (var i = 0; i < gifts.length; i++) {
      var g = gifts[i];
      if (keep && keep.key && g.key && g.key === keep.key) continue;
      if (keep && !keep.key && !g.key && g.line === keep.line) continue;
      remove.push(g);
    }

    log("[FreeGift] dedupe gifts. keep:", keep && (keep.key || keep.line), "remove:", remove.length);

    var chain = Promise.resolve(cart);
    remove.forEach(function (g) {
      chain = chain.then(function () {
        return setQtyWithSections(g, 0).then(function (state) {
          if (state) renderSections(state);
          return fetchCart();
        });
      });
    });

    return chain.catch(function () { return cart; });
  }

  function syncGift() {
    if (isSyncing) {
      needsResync = true;
      return Promise.resolve();
    }

    isSyncing = true;

    return fetchCart()
      .then(function (cart) {
        // Apply cached state quickly based on current cart
        applyLockFromCart(cart);
        return dedupeGiftsIfNeeded(cart);
      })
      .then(function (cart) {
        var eligible = calcEligibleCents(cart) >= THRESHOLD_CENTS;
        var gifts = findAllGiftLines(cart);
        var gift = bestGiftLine(gifts);

        log("[FreeGift] eligible", eligible, "gifts", gifts.length);

        // Eligible and no gift: add gift, immediately go pending to avoid flicker
        if (eligible && gifts.length === 0) {
          lastEligible = true;
          lastGiftPresent = true;
          lastGiftShouldLock = false;
          applyLockFromCacheToDom();

          return addGiftWithSections()
            .then(function (state) {
              renderSections(state);
              // Discount may apply slightly later
              return waitForGiftToBecomeFree(6, 250);
            })
            .then(function (cartAfterWait) {
              applyLockFromCart(cartAfterWait);
              return cartAfterWait;
            });
        }

        // Eligible and gift exists: enforce qty 1 for the chosen gift line
        if (eligible && gift) {
          // Keep pending immediately while discount settles
          lastEligible = true;
          lastGiftPresent = true;
          lastGiftShouldLock = giftDiscountActive(gift.item);
          applyLockFromCacheToDom();

          if (gift.item.quantity !== 1) {
            return setQtyWithSections(gift, 1)
              .then(function (state2) {
                if (state2) renderSections(state2);
                return fetchCart();
              })
              .then(function (newCart) {
                applyLockFromCart(newCart);
                return newCart;
              });
          }

          // If not free yet, wait a bit and then lock if it becomes free
          if (!giftDiscountActive(gift.item)) {
            return waitForGiftToBecomeFree(4, 200).then(function (laterCart) {
              applyLockFromCart(laterCart);
              return laterCart;
            });
          }

          applyLockFromCart(cart);
          return cart;
        }

        // Not eligible: do not remove gift, just clear states (controls visible)
        lastEligible = false;
        lastGiftShouldLock = false;
        applyLockFromCacheToDom();
        return cart;
      })
      .catch(function (e) {
        log("[FreeGift] error", e);
      })
      .finally(function () {
        isSyncing = false;
        if (needsResync) {
          needsResync = false;
          scheduleSync(80);
        }
      });
  }

  function scheduleSync(delayMs) {
    if (isSyncing) {
      needsResync = true;
      return;
    }
    if (scheduled) window.clearTimeout(scheduled);
    scheduled = window.setTimeout(function () {
      scheduled = null;
      syncGift();
    }, typeof delayMs === "number" ? delayMs : 160);
  }

  function hasHeader(init, key, expectedVal) {
    if (!init || !init.headers) return false;
    var h = init.headers;

    try {
      if (typeof Headers !== "undefined" && h instanceof Headers) {
        var v = h.get(key);
        return expectedVal ? String(v) === String(expectedVal) : v != null;
      }
      var direct = h[key] || h[key.toLowerCase()] || h[key.toUpperCase()];
      if (direct == null) return false;
      return expectedVal ? String(direct) === String(expectedVal) : true;
    } catch (e) {}

    return false;
  }

  function hookCartRequests() {
    // Dawn pubsub if present
    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      try {
        window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () {
          // Apply cached lock immediately for flicker, then sync
          applyLockFromCacheToDom();
          scheduleSync(120);
        });
      } catch (e) {}
    }

    // Patch fetch
    if (window.fetch) {
      var _fetch = window.fetch;
      window.fetch = function (input, init) {
        var url = "";
        try { url = typeof input === "string" ? input : (input && input.url) || ""; } catch (e) {}

        return _fetch.call(this, input, init).then(function (res) {
          try {
            if (hasHeader(init, "X-Module-FreeGift", "1")) return res;

            if (isCartUrl(url)) {
              // Apply cached lock immediately, then sync
              applyLockFromCacheToDom();

              // Faster than 650ms to reduce flicker; resync queue handles settling
              if (isAddUrl(url)) scheduleSync(180);
              else scheduleSync(140);
            }
          } catch (e) {}
          return res;
        });
      };
    }

    // Patch XHR
    if (window.XMLHttpRequest) {
      var XHROpen = XMLHttpRequest.prototype.open;
      var XHRSend = XMLHttpRequest.prototype.send;

      XMLHttpRequest.prototype.open = function (method, url) {
        this.__moduleFreeGiftUrl = url || "";
        return XHROpen.apply(this, arguments);
      };

      XMLHttpRequest.prototype.send = function () {
        var xhr = this;
        xhr.addEventListener("loadend", function () {
          try {
            var url = xhr.__moduleFreeGiftUrl || "";
            if (isCartUrl(url)) {
              applyLockFromCacheToDom();
              if (isAddUrl(url)) scheduleSync(180);
              else scheduleSync(140);
            }
          } catch (e) {}
        });
        return XHRSend.apply(this, arguments);
      };
    }

    // Remove click hook
    document.addEventListener(
      "click",
      function (e) {
        var t = e.target;
        if (!t) return;
        var looksRemove = t.closest("cart-remove-button") || t.closest(".cart-remove-button");
        if (looksRemove) {
          applyLockFromCacheToDom();
          scheduleSync(120);
        }
      },
      true
    );
  }

  // Re-apply cache after theme re-renders cart drawer
  function patchThemeRenderHooks() {
    try {
      var drawer = document.querySelector("cart-drawer");
      if (drawer && typeof drawer.renderContents === "function" && !drawer.__moduleFreeGiftPatched) {
        var orig = drawer.renderContents.bind(drawer);
        drawer.renderContents = function (state) {
          // Apply cached lock right after render to prevent flicker
          var out = orig(state);
          applyLockFromCacheToDom();
          scheduleSync(80);
          return out;
        };
        drawer.__moduleFreeGiftPatched = true;
      }

      var cartItems = document.querySelector("cart-items");
      if (cartItems && typeof cartItems.renderContents === "function" && !cartItems.__moduleFreeGiftPatched) {
        var orig2 = cartItems.renderContents.bind(cartItems);
        cartItems.renderContents = function (state2) {
          var out2 = orig2(state2);
          applyLockFromCacheToDom();
          scheduleSync(80);
          return out2;
        };
        cartItems.__moduleFreeGiftPatched = true;
      }
    } catch (e) {}
  }

  function startMutationObserver() {
    if (moStarted) return;
    moStarted = true;

    if (!document.body || !window.MutationObserver) return;

    try {
      var mo = new MutationObserver(function () {
        if (isRendering) return;
        patchThemeRenderHooks();
        // Apply cached lock instantly on DOM changes, then sync
        applyLockFromCacheToDom();
        scheduleSync(140);
      });
      mo.observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }

  document.addEventListener("DOMContentLoaded", function () {
    ensureStyles();
    hookCartRequests();
    patchThemeRenderHooks();
    startMutationObserver();
    scheduleSync(120);
  });
})();
